import LegalLayout from "@/components/LegalLayout";
import { LAST_UPDATED } from "@/constants/site";

const Terms = () => (
  <LegalLayout
    title="Terms & Conditions"
    updated={LAST_UPDATED}
    intro="These terms govern the services provided by Swarajya Solar Services, including solar consultation, supply, installation, subsidy assistance and maintenance. By engaging us or accepting a quotation, you agree to these terms."
    sections={[
      {
        heading: "Services We Provide",
        body: [
          "We provide site surveys, system design, supply and installation of on-grid, off-grid and hybrid solar systems, solar street lights, control panels and related electrical equipment, along with subsidy application support, net-metering coordination and after-sales maintenance.",
        ],
      },
      {
        heading: "Quotations & Site Survey",
        body: [
          "Site surveys and price estimates shared before agreement are indicative. A final quotation is issued after our engineer assesses your roof, shadow conditions, wiring and load requirements. Quotations are typically valid for 15 days from the date of issue, and are subject to change if equipment prices or government duties change materially.",
        ],
      },
      {
        heading: "Payments",
        body: [
          "Payment schedules are stated in each quotation. Unless agreed otherwise, an advance is payable on confirmation, and the balance is due on installation and commissioning. Prices are exclusive of any taxes unless stated. Work may be paused if scheduled payments are delayed.",
        ],
      },
      {
        heading: "Warranties",
        body: [
          "Warranty terms are those provided by the equipment manufacturer and as stated in your quotation:",
        ],
        list: [
          "Solar panels: 25–30 year linear performance warranty from the manufacturer",
          "Inverters: typically a 5-year manufacturer warranty (extendable per the manufacturer's policy)",
          "Installation workmanship: supported by our team; terms stated in your quotation",
          "Batteries and balance-of-system items: as per the respective manufacturer's warranty",
        ],
      },
      {
        heading: "Government Subsidy Disclaimer",
        body: [
          "Subsidies such as those under the PM Surya Ghar Muft Bijli Yojana are sanctioned by the relevant government authority and the electricity distribution company (DISCOM), not by Swarajya Solar Services. We assist with preparing and filing the application and following it up, but we cannot guarantee approval, the sanctioned amount, or the timeline of disbursement.",
        ],
      },
      {
        heading: "Delivery, Installation & Delays",
        body: [
          "Installation timelines start from receipt of advance and required approvals. We work to complete residential installations within a few working days of equipment delivery; however, delays caused by equipment availability, weather, DISCOM approvals or other factors beyond our reasonable control are not our responsibility. We will always keep you informed of expected timelines.",
        ],
      },
      {
        heading: "Customer Responsibilities",
        body: [
          "You agree to provide safe and lawful access to the installation site, ensure the roof or mounting structure is legally yours or that you have permission to install on it, and maintain the equipment as per manufacturer guidance or your AMC plan.",
        ],
      },
      {
        heading: "Limitation of Liability",
        body: [
          "To the extent permitted by law, our liability for any claim arising from our services is limited to the value stated in the relevant quotation for the equipment or service giving rise to the claim. We are not liable for indirect or consequential losses, including loss of power generation value caused by events beyond our control.",
        ],
      },
      {
        heading: "Governing Law",
        body: [
          "These terms are governed by the laws of India. Disputes are subject to the jurisdiction of courts in Maharashtra.",
        ],
      },
      {
        heading: "Contact",
        body: [
          "For any questions about these terms, call us at 98341 78018 during working hours (Mon – Sat, 8 AM – 8 PM).",
        ],
      },
    ]}
  />
);

export default Terms;
